import { extendTheme } from '@chakra-ui/react';

export const light = extendTheme({
  colors: {
    gray: {
      '50': '#181B23',
      '100': '#adb5bd',
      '200': '#353646',
      '300': '#4B4D63',
      '400': '#616480',
      '500': '#797D9A',
      '600': '#333',
      '650': '#adb5bd',
      '700': '#EEEEF2',
      '750': '#ced4da',
      '900': '#EEEEF2',
      '800': '#FEFEFE',
    },
    white: {
      '100': '#F8F8FB',
      '50': '#fff',
    },
    yellow: {
      '500': '#f2c811',
    },
  },

  fonts: {
    heading: 'Roboto',
    body: 'Roboto',
  },

  components: {
    // O Tooltip do Chakra v1 aplica bg/color a partir do styleConfig do tema
    // (useStyleConfig("Tooltip")). Definimos aqui o contraste (fundo escuro /
    // texto claro) para todos os tooltips do app. O bg também pinta a setinha.
    Tooltip: {
      baseStyle: {
        bg: '#1e293b',
        color: '#f8fafc',
        '--popper-arrow-bg': '#1e293b',
        borderRadius: 'md',
        fontSize: 'xs',
        px: 3,
        py: 1.5,
      },
    },
  },

  styles: {
    global: {
      body: {
        bg: 'white.100',
        color: 'gray.600',
        transition: '1s',
        webkitFontSmoothing: 'antialiased',

        h1: {
          fontWeight: '500',
          fontSize: '24px',
        },
        h2: {
          fontWeight: '500',
        },
        h3: {
          fontWeight: '500',
        },
        h4: {
          fontWeight: '500',
        },
        h5: {
          fontWeight: '500',
        },
        h6: {
          fontWeight: '500',
        },
        strong: {
          fontWeight: '500',
        },
        select: {
          fontWeight: '500',
        },
      },
    },
  },
});
